import React, { Suspense, useEffect, useState } from 'react';
import { isBrowser } from './Browser';
import { OpenReplayWrapper } from './OpenReplayWrapper';
import log from 'loglevel';
import {
  ENABLE_OPEN_REPLAY_IN_DEVELOPMENT,
  IS_DEVELOPMENT,
  OPEN_REPLAY_PROJECT_KEY,
} from 'api-config.mjs';


// Mirrors `LogRocketLazyLoader.shouldCreateLogRocket` so OpenReplay
// honors the same bot/headless detection rules. Keep the two in sync —
// any new bot signal added there should be added here too.
const shouldCreateOpenReplay = () => {
  if (!isBrowser()) {
    return true;  // Ensure the component is bundled at build time
  }

  if (!OPEN_REPLAY_PROJECT_KEY) {
    log.debug("OPEN_REPLAY_PROJECT_KEY is not configured for this stage, skipping OpenReplay initialization.");
    return false;
  }

  if (IS_DEVELOPMENT) {
    return ENABLE_OPEN_REPLAY_IN_DEVELOPMENT;
  }

  const { userAgent } = navigator;
  log.debug(`OpenReplay: got userAgent: ${userAgent}`);

  if (userAgent?.includes("HeadlessChrome")) {
    log.info("Detected Headless Chrome, skipping OpenReplay initialization.");
    return false;
  }
  if (userAgent?.includes("Chrome-Lighthouse")) {
    log.info("Detected Chrome-Lighthouse, skipping OpenReplay initialization.");
    return false;
  }
  if (userAgent?.includes("BingPreview")) {
    log.info("Detected BingPreview, skipping OpenReplay initialization.");
    return false;
  }

  if (userAgent === "cca-app-tester") {
    log.info("Detected cca-app-tester, skipping OpenReplay initialization.");
    return false;
  }

  return true;
};

const OpenReplayLazyLoader = () => {

  log.debug("OpenReplayLazyLoader::render()");

  const [ createOpenReplay, setCreateOpenReplay ] = useState(false);

  useEffect(() => {
    if (shouldCreateOpenReplay()) {
      log.debug("Creating OpenReplay Wrapper Component..");
      setCreateOpenReplay(true);
    }
  }, []);

  if (!createOpenReplay) {
    return (<></>);
  }

  return (
    <>
      <Suspense fallback={<></>}>
        <OpenReplayWrapper />
      </Suspense>
    </>
  );
};

export {
  OpenReplayLazyLoader
};
